var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsciiText } from '../framework/AsciiText';
export class SamsungPro {
    constructor(socket, log) {
        this.socket = socket;
        this.firmwareVersion = Array.from(AsciiText.encode('T-GFSLE2AKUC-1037.2'));
        this.id = 0;
        this.mute = false;
        this.pictureSize = 0x10; // 16:9
        this.power = false;
        // Last 3 bytes of the serial number are reserved bytes to get the serial number length to 19 bytes
        this.serialNumber = Array.from(AsciiText.encode('044DHCFJ800198Bxxx'));
        this.validVideoInputs = [
            0x04,
            0x08,
            0x0c,
            0x0d,
            0x0e,
            0x14,
            0x18,
            0x1e,
            0x1f,
            0x20,
            0x21,
            0x22,
            0x23,
            0x24,
            0x25,
            0x26,
            0x27,
            0x31,
            0x32,
            0x33,
            0x34,
            0x40,
            0x50,
            0x55,
            0x56,
            0x60,
            0x61,
            0x62,
            0x63,
            0x64,
            0x65, // web browser
        ];
        this.videoInput = 0x21; // hdmi1
        this.volume = 0;
        this.volumeMax = 100;
        this.volumeMin = 0;
        this.asyncHandlers = [
            {
                name: 'firmwareVersionGet',
                regExp: this.makeRegExp(0x0e),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (this.power) {
                        this.sendAck(0x0e, this.firmwareVersion);
                    }
                    else {
                        this.sendNak(0x0e);
                    }
                },
            },
            {
                name: 'muteGet',
                regExp: this.makeRegExp(0x13),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (this.power) {
                        this.sendAck(0x13, this.mute ? 1 : 0);
                    }
                    else {
                        this.sendNak(0x13);
                    }
                },
            },
            {
                name: 'muteSet',
                regExp: this.makeRegExp(0x13, 1),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (!this.power || (bytes[4] !== 0 && bytes[4] !== 1)) {
                        this.sendNak(0x13);
                        return;
                    }
                    this.mute = bytes[4] === 1;
                    this.sendAck(0x13, this.mute ? 1 : 0);
                },
            },
            {
                name: 'powerGet',
                regExp: this.makeRegExp(0x11),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    this.sendAck(0x11, this.power ? 1 : 0);
                },
            },
            {
                name: 'powerSet',
                regExp: this.makeRegExp(0x11, 1),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (bytes[4] !== 0 && bytes[4] !== 1) {
                        this.sendNak(0x11);
                        return;
                    }
                    this.power = bytes[4] === 1;
                    this.sendAck(0x11, this.power ? 1 : 0);
                },
            },
            {
                name: 'serialNumberGet',
                regExp: this.makeRegExp(0x0b),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (this.power) {
                        this.sendAck(0x0b, this.serialNumber);
                    }
                    else {
                        this.sendNak(0x0b);
                    }
                },
            },
            {
                name: 'statusGet',
                regExp: this.makeRegExp(0x00),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    this.sendAck(0x00, [
                        this.power ? 1 : 0,
                        this.volume,
                        this.mute ? 1 : 0,
                        this.videoInput === 0x18 ? 0x1f : this.videoInput,
                        this.pictureSize,
                        0,
                        0, // f time nf
                    ]);
                },
            },
            {
                name: 'videoInputGet',
                regExp: this.makeRegExp(0x14),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (this.power) {
                        this.sendAck(0x14, this.videoInput);
                    }
                    else {
                        this.sendNak(0x14);
                    }
                },
            },
            {
                name: 'videoInputSet',
                regExp: this.makeRegExp(0x14, 1),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (!this.power || !this.validVideoInputs.includes(bytes[4])) {
                        this.sendNak(0x12);
                        return;
                    }
                    this.videoInput = bytes[4];
                    this.sendAck(0x14, this.videoInput);
                },
            },
            {
                name: 'volumeGet',
                regExp: this.makeRegExp(0x12),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (this.power) {
                        this.sendAck(0x12, this.volume);
                    }
                    else {
                        this.sendNak(0x12);
                    }
                },
            },
            {
                name: 'volumeSet',
                regExp: this.makeRegExp(0x12, 1),
                callback: (match) => {
                    const bytes = Array.from(AsciiText.encode(match[0]));
                    const checksum = this.computeChecksum(bytes);
                    if (checksum !== bytes[bytes.length - 1])
                        return;
                    if (!this.power || bytes[4] < this.volumeMin || bytes[4] > this.volumeMax) {
                        this.sendNak(0x12);
                        return;
                    }
                    this.volume = bytes[4];
                    this.sendAck(0x12, this.volume);
                },
            },
        ];
        this.socket.onBeforeConnect(this.onBeforeConnect.bind(this));
    }
    computeChecksum(bytes) {
        let checksum = 0;
        for (let i = 1; i < bytes.length - 1; i++) {
            checksum += bytes[i];
        }
        return checksum & 0x00ff;
    }
    makeCommand(command, data = []) {
        const bytes = [0xaa, command, this.id, data.length, ...data, 0];
        bytes[data.length + 4] = this.computeChecksum(bytes);
        return AsciiText.decode(bytes);
    }
    makeRegExp(command, numDataBytes = 0) {
        let str = '\\xaa';
        str += this.numToRegExpStr(command);
        str += this.numToRegExpStr(this.id);
        str += this.numToRegExpStr(numDataBytes);
        if (numDataBytes > 0) {
            str += `([\\s\\S]){${numDataBytes}}`;
        }
        str += `([\\s\\S])`; // checksum
        return new RegExp(str);
    }
    numToRegExpStr(value) {
        return value < 16 ? `\\x0${value.toString(16)}` : `\\x${value.toString(16)}`;
    }
    onBeforeConnect(host, port, username, password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.socket.setCanConnect(port !== 1515 || this.power);
        });
    }
    onConfigure(config) {
        var _a;
        let lowestCode;
        for (const videoInput of Object.values((_a = config.videoInputs) !== null && _a !== void 0 ? _a : {})) {
            const code = videoInput.code.charCodeAt(0);
            if (this.videoInput === code - 0x30)
                return;
            if (lowestCode === undefined || code < lowestCode) {
                lowestCode = code;
            }
        }
        this.videoInput = (lowestCode !== null && lowestCode !== void 0 ? lowestCode : 0x21) - 0x30;
    }
    sendAck(command, data = []) {
        if (typeof data === 'number')
            data = [data];
        this.socket.send(this.makeCommand(0xff, [0x41, command, ...data]));
    }
    sendNak(command) {
        this.socket.send(this.makeCommand(0xff, [0x4e, command, 0x01]));
    }
    wakeOnLan() {
        this.power = true;
        this.socket.setCanConnect(this.socket.getPort() !== 1515 || this.power);
    }
}
SamsungPro.emulatorType = 'socketEmulator';
SamsungPro.key = '-LBR-2ML9LcxruxmjyEH';
